<template>
  <div>
    <!-- tab -->
    <comment-header
      :fathertitle="fathertitle"
      :childtitle="childtitle"
      :path="path"
    >
    </comment-header>

    <config-form
      ref="configForm"
      :title="configFormTitle"
      :visible="configFormVisible"
      :model="mdl"
      :userDataList="configFormUserDataList"
      :currentUserId="configFormSelectUserId"
      :resourceDataList="configFormResourceDataList"
      :modelDataList="configFormModelDataList"
      @cancel="handleCancel"
      @ok="handleOk"
    >
    </config-form>

    <task-log
      ref="taskLog"
      :title="taskLogTitle"
      :visible="taskLogVisible"
      :loading="taskLogLoading"
      :ldata="logListData"
      @cancel="logCancel()"
    >
    </task-log>

    <a-card style="width: 100%" :bordered="false">
      <!-- 搜索区域 -->
      <div slot="extra">
        <a-radio-group
          v-model="queryParams.status"
          @change="selectQueryStatusChange"
        >
          <a-radio-button value="-1">全部</a-radio-button>
          <a-radio-button value="0">待训练</a-radio-button>
          <a-radio-button value="4">等待处理</a-radio-button>
          <a-radio-button value="1">进行中</a-radio-button>
          <a-radio-button value="2">中断</a-radio-button>
          <a-radio-button value="3">完成</a-radio-button>
        </a-radio-group>
        <a-select
          show-search
          style="margin-left: 16px; width: 272px"
          :filter-option="userListFilter"
          v-model="queryParams.userId"
          @select="selectQueryUserChange"
        >
          <a-select-option
            :key="item.id"
            :value="item.id"
            v-for="item in userDataList"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div slot="title">
        <span>任务列表</span>
        <a-button
          type="primary"
          @click="addTask()"
          style="margin-left: 30px"
          icon="plus"
          >添加</a-button
        >
      </div>

      <a-table
        :columns="columns"
        :bordered="true"
        :data-source="taskListData"
        :rowKey="(record) => record.id"
        :pagination="{
          pageSize: pagination.pageSize,
          total: pagination.totalCount,
          current: pagination.pageIndex,
          onChange: changePage,
        }"
      >
        <div slot="status" slot-scope="text, record" class="status">
          <div v-if="text == 0">待训练</div>
          <div v-if="text == 1">训练中</div>
          <div v-if="text == 2">
            中断
            <a-icon
              @click="errorMsg(record)"
              style="color: red; cursor: pointer"
              type="exclamation-circle"
            />
          </div>
          <div v-if="text == 3">完成</div>
          <div v-if="text == 4">等待处理</div>
          <div v-if="text == 42">等待中断处理</div>
        </div>

        <div slot="startTime" slot-scope="text">
          {{ text ? text : "/" }}
        </div>
        <div slot="completeTime" slot-scope="text">
          {{ text ? text : "/" }}
        </div>
        <!-- <div v-if="item.status == 1 || item.status == 2" class="list-content-item">
          <a-progress :percent="item.progress.value" style="width: 180px" />
        </div> -->
        <div slot="progress" slot-scope="text, record">
          <div
            v-if="record.status == 1 || record.status == 2"
            class="list-content-item"
          >
            <a-progress :percent="record.progress" style="width: 180px" />
          </div>
          <div v-if="record.status == 3">已完成</div>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            v-if="
              record.status == 0 || record.status == 2 || record.status == 3
            "
            @click="startTrain(record)"
          >
            <a-icon type="play-circle" />
            开始训练
          </a-button>
          <span v-else> </span>
        </div>

        <div slot="actions" slot-scope="text, record">
          <a-dropdown>
            <a-menu theme="light" slot="overlay">
              <a-menu-item class="menuItem" @click="editTask(record)"
                ><a>编辑</a></a-menu-item
              >
              <a-menu-item class="menuItem" @click="removeTask(record)"
                ><a>删除</a></a-menu-item
              >
              <a-menu-item class="menuItem" @click="lookTaskLog(record)"
                ><a>查看训练日志</a></a-menu-item
              >
              <a-menu-item class="menuItem" v-if="record.status == 3"
                ><a @click="downloadSecretModel(record, $event)"
                  >下载模型(加密)</a
                ></a-menu-item
              >
              <a-menu-item
                class="menuItem"
                v-if="record.status == 3 && showDown"
                ><a @click="downloadTrainModel2(record, $event)"
                  >下载模型(非加密)</a
                ></a-menu-item
              >
            </a-menu>
            <a-button>更多<a-icon type="down" /></a-button>
          </a-dropdown>
        </div>
      </a-table>
    </a-card>
  </div>
</template>

 <script>
import CommentHeader from "@components/header";
import * as semiManagement from "@/api/semi_management";
import { requestUrl } from "@utils/request_url";
import ConfigForm from "./ConfigForm";
import TaskLog from "./TaskLog";
import { getCurrentOwnUserList } from "@api/userManagement";
import pick from "lodash.pick";
const taskListData = [];
const columns = [
  {
    title: "资源库",
    width: 300,
    dataIndex: "resourceName",
    key: "resourceName",
    align: "center",
  },

  {
    title: "状态",
    width: 90,
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    align: "center",
  },
  {
    title: "提交时间",
    width: 180,
    dataIndex: "submitTime",
    key: "submitTime",
    align: "center",
  },
  {
    title: "开始时间",
    width: 180,
    dataIndex: "startTime",
    key: "startTime",
    scopedSlots: { customRender: "startTime" },
    align: "center",
  },
  {
    title: "完成时间",
    width: 180,
    dataIndex: "completeTime",
    key: "completeTime",
    scopedSlots: { customRender: "completeTime" },
    align: "center",
  },
  {
    title: "进度",
    width: 280,
    dataIndex: "progress",
    key: "progress",
    scopedSlots: { customRender: "progress" },
    align: "center",
  },
  {
    title: "训练操作",
    width: 150,
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    align: "center",
  },
  {
    title: "操作",
    width: 120,
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    align: "center",
  },
];

export default {
  name: "SemiTaskManagement",
  components: {
    CommentHeader,
    ConfigForm,
    TaskLog,
  },

  data() {
    return {
      columns,
      taskListData,
      userDataList: [],
      resourceList: [],
      selectUserId: "",
      selectResourceId: 0,

      // tab头部
      fathertitle: "半监督学习",
      childtitle: "任务管理(半监督)",
      path: "/train/project-list",

      //
      configFormTitle: "",
      mdl: null,
      queryParams: {
        userId: "",
        status: "-1",
      },
      configFormVisible: false,

      updateStatusProgressTime: null,
      showDown: false,
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0,
      },
      configFormUserDataList: [],
      configFormSelectUserId: "",
      configFormResourceDataList: [],
      configFormModelDataList: [],
      getTrainLogTime: null,

      taskLogTitle: "训练日志",
      taskLogVisible: false,
      taskLogLoading: false,
      logListData: [],
      currentTaskId: 0,
      currentLogId: 0,
    };
  },
  beforeDestroy() {
    window.clearInterval(this.updateStatusProgressTime);
    window.clearInterval(this.getTrainLogTime);
  },
  mounted() {
    this.loadUserList();
    this.loadTaskList();
    this.updateStatusProgressTime = setInterval(
      this.updateStatusProgress,
      1000
    );
    this.loadModelList();
  },
  methods: {
    loadModelList() {
      // 目前只支持半监督学习
      const self = this;
      semiManagement.getAllModelList().then((res) => {
        res.data.forEach((r) => {
          if (r.name.indexOf("半监督") > 0) {
            self.configFormModelDataList.push({
              id: r.id,
              name: r.name,
            });
          }
        });
      });
      if (this.configFormModelDataList.length == 0) {
        this.configFormModelDataList.push({ id: "45", name: "半监督MPL分类" });
      }
    },
    changePage(current, page) {},
    loadUserList() {
      const that = this;
      getCurrentOwnUserList().then((res) => {
        that.userDataList = [];
        that.configFormUserDataList = [];
        that.userDataList.push({ id: "", name: "全部账户" });
        var list = res.data;
        if (list != null && list.length > 0) {
          for (var i = 0; i < list.length; i++) {
            that.userDataList.push({
              id: list[i].id,
              name: list[i].accountRealName,
            });
            that.configFormUserDataList.push({
              id: list[i].id,
              name: list[i].accountRealName,
            });
          }
          if (that.configFormUserDataList.length > 0) {
            that.configFormSelectUserId = that.configFormUserDataList[0].id;
            //
            semiManagement
              .getResourceListApi({ userId: that.configFormSelectUserId })
              .then((r) => {
                that.configFormResourceDataList = r.data;
              });
          }
        }
      });
    },
    userListFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    loadTaskList() {
      const that = this;
      semiManagement
        .getTaskPageApi({
          pageIndex: that.pagination.pageIndex,
          pageSize: that.pagination.pageSize,
          userId: this.queryParams.userId,
          status: that.queryParams.status,
        })
        .then((res) => {
          that.taskListData = res.data.list;
          that.pagination.totalCount = res.data.totalRecords;
        });
    },
    selectQueryStatusChange(e) {
      this.queryParams.status = e.target.value;
      this.loadTaskList();
    },
    selectQueryUserChange(v, o) {
      this.queryParams.userId = v;
      this.loadTaskList();
    },

    addTask() {
      const that = this;
      this.configFormTitle = "新增任务";
      that.configFormVisible = true;
      this.mdl = {
        id: 0,
        userId: "",
        resourceId: 0,
        trainCount: "",
        trainThreshold: "",
        modelId: "",
        rotateAugmentation: 0,
        colourAugmentation: 0,
      };

      if (that.configFormUserDataList.length > 0)
        that.mdl.userId = that.configFormUserDataList[0].id;
      else that.mdl.userId = "";
      if (that.configFormResourceDataList.length > 0)
        that.mdl.resourceId = that.configFormResourceDataList[0].id;
      else that.mdl.resourceId = null;
    },

    editTask(record) {
      const that = this;
      semiManagement.getTaskApi({ id: record.id }).then((res) => {
        semiManagement
          .getResourceListApi({ userId: res.data.ownResourceUserId })
          .then((r) => {
            that.configFormResourceDataList = r.data;
            that.mdl = {
              id: record.id,
              userId: res.data.ownResourceUserId,
              trainCount: res.data.trainCount,
              resourceId: res.data.resourceId,
              trainThreshold: res.data.trainThreshold,
              numClass: res.data.numClass,
              cbatchSize: res.data.cbatchSize,
              imageHeight: res.data.imageHeight,
              imageWidth: res.data.imageWidth,
              rotateAugmentation: 0,
              colourAugmentation: 0,
              modelId: res.data.modelId,
            };
            if (res.data.rotateAugmentation) {
              that.mdl.rotateAugmentation = 1;
            }
            if (res.data.colourAugmentation) {
              that.mdl.colourAugmentation = 1;
            }
            that.configFormTitle = "编辑任务";
            that.configFormVisible = true;
          });
      });
    },
    removeTask(record) {
      const that = this;
      this.$confirm({
        title: `你想要删除此项吗?`,
        content: `当你点击确认按钮时, 这个对话框将会在删除成功时关闭`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              semiManagement.removeTask({ id: record.id }).then((r) => {
                that.pagination.pageIndex = 1;
                that.loadTaskList();
              });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },
    handleOk(data) {
      const that = this;
      const id = this.mdl.id;
      if (id == 0) {
        semiManagement
          .addTask({
            resourceId: data.resourceId,
            trainCount: data.trainCount,
            trainThreshold: data.trainThreshold,
            numClass: data.numClass,
            cbatchSize: data.cbatchSize,
            imageHeight: data.imageHeight,
            imageWidth: data.imageWidth,
            rotateAugmentation: data.rotateAugmentation === 0 ? false : true,
            colourAugmentation: data.colourAugmentation === 0 ? false : true,
            modelId: data.modelId,
          })
          .then((res) => {
            that.$refs.configForm.form.resetFields();
            that.configFormVisible = false;
            that.loadTaskList();
            that.$message.info("保存成功");
          });
      } else {
        semiManagement
          .updateTask({
            id: id,
            resourceId: data.resourceId,
            trainCount: data.trainCount,
            trainThreshold: data.trainThreshold,
            numClass: data.numClass,
            cbatchSize: data.cbatchSize,
            imageHeight: data.imageHeight,
            imageWidth: data.imageWidth,
            rotateAugmentation: data.rotateAugmentation === 0 ? false : true,
            colourAugmentation: data.colourAugmentation === 0 ? false : true,
            modelId: data.modelId,
          })
          .then((res) => {
            that.$refs.configForm.form.resetFields();
            that.configFormVisible = false;
            that.loadTaskList();
            that.$message.info("更新成功");
          });
      }
    },
    handleCancel() {
      if (
        this.$refs.configForm !== undefined ||
        this.$refs.configForm.form !== undefined
      ) {
        this.$refs.configForm.form.resetFields();
      }
      this.configFormVisible = false;
    },
    updateStatusProgress() {
      var ids = [];
      const that = this;
      if (this.taskListData != null && this.taskListData.length > 0) {
        ids = this.taskListData.map((item) => {
          return item.id;
        });
        semiManagement.getTaskListStatus(ids).then((r) => {
          for (let index = 0; index < r.data.length; index++) {
            const element = r.data[index];
            that._updateStatusProgress(that.taskListData, element);
          }
        });
      }
    },
    _updateStatusProgress(data, _data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.id === _data.id) {
          if (element.status !== _data.status) element.status = _data.status;
          element.progress = _data.progress;
          element.startTime = _data.startTime;
          element.completeTime = _data.completeTime;
        }
      }
    },

    errorMsg(record) {
      semiManagement.getTaskBreakError({ id: record.id }).then((res) => {
        this.$error({
          title: "错误信息提示",
          content: `${res.data}`,
        });
      });
    },
    startTrain(record) {
      const that = this;
      this.$confirm({
        title: `你想要开始执行训练吗?`,
        content: `当你点击确认按钮时, 这个对话框将会在执行成功后关闭`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              semiManagement.startTastTrain({ id: record.id }).then((r) => {});
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },
    lookTaskLog(record) {
      const that = this;
      that.currentTaskId = record.id;
      semiManagement.getLastLogList({ id: record.id }).then((res) => {
        var rdata = res.data;
        if (rdata != null && rdata.length > 0) {
          that.logListData = rdata;
          that.currentLogId = rdata[0].id;
        } else {
          that.currentLogId = 0;
        }
        that.taskLogVisible = true;
        that.getTrainLogTime = setInterval(that.getNextLog, 1000);
      });
    },
    logCancel() {
      this.taskLogVisible = false;
      window.clearInterval(this.getTrainLogTime);
    },
    getNextLog() {
      const that = this;
      semiManagement
        .getNextLog({ id: this.currentTaskId, logId: this.currentLogId })
        .then((res) => {
          var rdata = res.data;
          if (rdata != null) {
            that.logListData.unshift(rdata);
            that.currentLogId = rdata.id;
          }
        });
    },
    /**
     * 下载加密模型
     * @param {*} record
     */
    downloadSecretModel(record, event) {
      const userid = localStorage.getItem("user_id");
      if (userid == "1b65360154b0447884fb707e9a89e183") {
        window.location.href =
          requestUrl +
          "/train/rest/file/download_semi_train_model_onnx/" +
          record.id;
      } else {
        window.location.href =
          requestUrl +
          "/train/rest/file/download_semi_train_model/" +
          record.id;
      }
    },
    /**
     * 下载非加密模型
     * @param {*} record
     */
    downloadTrainModel2(record, event) {
      const userid = localStorage.getItem("user_id");
      if (
        userid == "1e18f0a07b6647a692c8a9a4b29dd875" ||
        userid == "00f17ec113f74a4180e58d647f0352a1"
      ) {
        window.location.href =
          requestUrl +
          "/train/rest/file/download_semi_train_model_onnx/" +
          record.id;
      }
    },
  },
};
</script>
 
 <style lang="scss" scoped>
</style>
 